<template lang="pug">
	main.p-page.home

		include ../includes/header.pug
		
		section().hero.pt-3.pb-5
			.background
				.background-image(style="background-image: url('images/core_paper_tube_open_front.jpg');", attr-animate-fadeIn)
			.container
				.row
					.col-12.col-lg-8
						h6(attr-animate='0').mb-3 Paihuen.co
						h2(attr-animate='0').display-4 Lleva tu piel a su estado natural.
						p(attr-animate='0').lead.mt-4 Ingredientes y productos para el equilibrio de la piel 
						small(attr-animate='0').my-4.d-block 🌿 Naturalskincare ⚗️ Nontoxic 🐇 Crueltyfree 🇨🇱 ISP
						button.btn.btn-pill.btn-outline-primary(attr-animate='5', @click="scrollTo('products')") Productos

		include ../includes/products.pug

		section.pt-5(attr-animate='12')
			.container
				.row
					.col-8
						h6 Paihuen
						h3.font-normal Entrega equilibrio a tu cuerpo nutriendo tu piel 
							b sin daños colaterales.
						p.text-hint Descubre las increíbles propiedades de nuestros productos.


		section(attr-animate='12').pt-5
			.container
				.row.justify-content-end
					.icon.col-4
						svg#nutrition(x='0px', y='0px', viewBox='0 0 84.4 84.2', xml:space='preserve', height="120")
							path.st0.jlsgboen_0(d='M19.4,71.3c0.1-1.3,1.2-9.3,9.8-15.8c3.6-2.7,5.4-5.6,5.4-8.6c0-2.3-1-4.1-1.8-5.2c0.9-0.4,1.7-1,2.4-1.8 c1.2-1.4,1.8-3.2,1.8-5.1c0-2.8-1.2-5.3-3.2-6.6c0.5-1.1,0.8-2.2,0.8-3.5c0-3.1-1.5-5.8-3.9-7c0.1-0.5,0.2-1,0.2-1.5 c0-1.9-0.6-3.8-1.7-5.2c-0.9-1.2-2.1-1.9-3.4-2.2c-0.1-3.8-2.8-6.9-6.1-7c-3.2,0-6,2.9-6.3,6.7c-3.1,0.3-5.6,3.4-5.7,7.2 c0,0.7,0.1,1.4,0.2,2c-1.9,1.3-3.2,3.7-3.2,6.3c0,1.2,0.2,2.4,0.7,3.4c-2.1,1.2-3.5,3.7-3.5,6.5c0,1.9,0.6,3.8,1.7,5.2 C4.2,40.3,5,40.9,6,41.3c-0.9,1.1-1.9,2.9-1.9,5.1c0,3,1.7,6,5.2,8.8C17.4,61.8,19.4,69.8,19.4,71.3')
							path.st0.jlsgboen_1(d='M61.8,2.3c-0.4-0.6-1.4-0.5-1.7,0.1c-1,1-5.5,6.1-10,13c-6.8,10.4-10.3,19.8-10.3,27.9 c0,17.9,12.9,30.3,15.3,32.3c0.1,1,0.4,3.2,1.9,4.8c1,1,2.4,1.6,4,1.6c1.6,0,3-0.5,4-1.6c1.5-1.5,1.8-3.8,1.8-4.8 c2.4-2.1,15.3-14.4,15.3-32.3c0-8.1-3.4-17.5-10.3-27.9C67.3,8.3,62.7,3.2,61.8,2.3z')
							path.st0.jlsgboen_2(d='M53.4,49.4h-3.3c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h3.3c1.2,0,2.2,1,2.2,2.2S54.6,49.4,53.4,49.4z')
							path.st0.jlsgboen_3(d='M53.7,27h-0.9c-1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9h0.9c1,0,1.9,0.8,1.9,1.9S54.7,27,53.7,27z')
							path.st0.jlsgboen_4(d='M53.4,60.8h-1.1c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h1.1c1.2,0,2.2,1,2.2,2.2S54.6,60.8,53.4,60.8z')
							path.st0.jlsgboen_5(d='M68.6,45h3.3c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2h-3.3c-1.2,0-2.2-1-2.2-2.2S67.4,45,68.6,45z')
							path.st0.jlsgboen_6(d='M53.4,38.1h-3.3c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2h3.3c1.2,0,2.2,1,2.2,2.2S54.6,38.1,53.4,38.1z')
							path.st0.jlsgboen_7(d='M68.6,33.7h3.3c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2h-3.3c-1.2,0-2.2-1-2.2-2.2S67.4,33.7,68.6,33.7z')
							path.st0.jlsgboen_8(d='M68.2,23.3h0.9c1,0,1.9,0.8,1.9,1.9S70.2,27,69.2,27h-0.9c-1,0-1.9-0.8-1.9-1.9S67.2,23.3,68.2,23.3z')
							path.st0.jlsgboen_9(d='M68.6,56.4h1.1c1.2,0,2.2,1,2.2,2.2s-1,2.2-2.2,2.2h-1.1c-1.2,0-2.2-1-2.2-2.2S67.4,56.4,68.6,56.4z')
							path.st0.jlsgboen_10(d='M61,73.1L61,16')
							path.st0.jlsgboen_11(d='M19.4,81.9L19.4,23.2')
							path.st0.jlsgboen_12(d='M19.4,43c6.3-6.3,6.3-6.3,6.3-6.3')
							path.st0.jlsgboen_13(d='M19.4,30.8c6.3-6.3,6.3-6.3,6.3-6.3')
							path.st0.jlsgboen_14(d='M19.4,43c-6.3-6.3-6.3-6.3-6.3-6.3')
							path.st0.jlsgboen_15(d='M19.4,55.7c6.3-6.3,6.3-6.3,6.3-6.3')
							path.st0.jlsgboen_16(d='M19.4,55.7c-6.3-6.3-6.3-6.3-6.3-6.3')
							path.st0.jlsgboen_17(d='M19.4,30.8c-6.3-6.3-6.3-6.3-6.3-6.3')
					.col-8
						h5 Nativa
						p.text-hint Utilizamos ingredientes endémicos de alta calidad, con concentraciones excepcionales de aceites escenciales y activos vegetales salutogénicos.
		section(attr-animate='12').pt-5
			.container
				.row.justify-content-end
					.icon.col-4
						svg#cycling(x='0px', y='0px', viewBox='0 0 82.5 86.2', xml:space='preserve', height="120")
							path.st0.hbMyISlP_0(d='M21.9,9.4c1.4,0.3,4.4,1.1,5.7,3.2c1.3,2.1,0.5,5.2,0.1,6.6c-1.4-0.3-4.4-1.1-5.7-3.2  C20.7,13.8,21.4,10.8,21.9,9.4z')
							path.st0.hbMyISlP_1(d='M9.1,46.1C9.1,46.1,9.1,46.1,9.1,46.1c-2.5,0-4.7-2.2-5.7-3.2c0.9-1.1,3.2-3.3,5.7-3.3c0,0,0,0,0,0c0,0,0,0,0,0  c2.5,0,4.7,2.2,5.7,3.2C13.8,43.9,11.6,46.1,9.1,46.1z')
							path.st0.hbMyISlP_2(d='M21.6,70c1.2-2.2,4.2-3,5.7-3.3c0.5,1.4,1.3,4.4,0,6.6c-1.2,2.2-4.2,3-5.7,3.3C21.2,75.1,20.4,72.1,21.6,70z')
							path.st0.hbMyISlP_3(d='M54.6,66.8c1.4,0.3,4.4,1.1,5.7,3.2c1.3,2.1,0.5,5.2,0.1,6.6c-1.4-0.3-4.4-1.1-5.7-3.2  C53.4,71.3,54.2,68.2,54.6,66.8z')
							path.st0.hbMyISlP_4(d='M73.2,46.5C73.2,46.5,73.2,46.5,73.2,46.5c-2.5,0-4.7-2.2-5.7-3.2c0.9-1.1,3.2-3.3,5.7-3.3c0,0,0,0,0,0  c2.5,0,4.7,2.2,5.7,3.2C77.9,44.3,75.7,46.5,73.2,46.5z')
							path.st0.hbMyISlP_5(d='M60.6,16.1c-1.2,2.2-4.2,3-5.7,3.3c-0.5-1.4-1.3-4.4,0-6.6c1.2-2.2,4.2-3,5.7-3.3C61.1,10.9,61.9,14,60.6,16.1z  ')
							g
								path.st0.hbMyISlP_6(d='M54.9,33.7')
								path.st0.hbMyISlP_7(d='M26.9,33.7c7.7-7.7,20.3-7.7,28,0')
								path.st0.hbMyISlP_8(d='M48.8,40c6.3-6.3,6.3-6.3,6.3-6.3')
								path.st0.hbMyISlP_9(d='M55.1,33.7c0-8.9,0-8.9,0-8.9')
							g
								path.st0.hbMyISlP_10(d='M54.9,51.7c-7.7,7.7-20.3,7.7-28,0')
								path.st0.hbMyISlP_11(d='M26.9,51.7')
								path.st0.hbMyISlP_12(d='M26.8,51.7c6.3-6.3,6.3-6.3,6.3-6.3')
								path.st0.hbMyISlP_13(d='M26.8,60.6c0-8.9,0-8.9,0-8.9')
							path.st0.hbMyISlP_14(d='M41.1,3L41.1,12.1')
							path.st0.hbMyISlP_15(d='M41.1,74L41.1,83')
							path.st0.hbMyISlP_16(d='M74.7,64.8L67.1,59.9')
							path.st0.hbMyISlP_17(d='M15.2,26.2L7.6,21.3')
							path.st0.hbMyISlP_18(d='M74.7,21.3L67.1,26.2')
							path.st0.hbMyISlP_19(d='M15.2,59.9L7.6,64.8')
							path.st0.hbMyISlP_20(d='M41.1,83L41.1,74')
							path.st0.hbMyISlP_21(d='M41.1,12.1L41.1,3')
					.col-8
						h5 Libres de tóxicos.
						p.text-hint Utilizamos solo cosas que tu cuerpo puede procesar. Somos 100% libres de GMO y agrotóxicos, parabenos, siliconas, sulfatos, derivados del petróleo, colorantes, perfumes sintéticos y frangancias.
		section(attr-animate='12').pt-5
			.container
				.row.justify-content-end
					.icon.col-4
						svg#crueltyfree(x='0px', y='0px', viewBox='0 0 82.5 86.2', style='', xml:space='preserve', height="120")
							g
								path.st0.hdYAsfaE_0(d='M37.9,56.7c6.1,0,12.5,3.9,16.7,7.1c4.8,3.7,8.1,7.4,8.1,7.4c0.9,1,2.4,1.3,3.6,0.6c1.2-0.7,1.8-2.1,1.3-3.4\
								l-3.8-11.5c1.3,0.3,2.8,0.5,4.3,0.5c3.9,0,7.2-1.2,9.6-3.6c6.9-6.7-2.2-18.5-5.3-22.2c2.1-2.6,3.3-5.1,3.6-7.4\
								c0.1-0.6,0.2-2.6,0.2-3.1c-0.1-2.1-1.1-4-2.6-5.4c-1.6-1.4-3.6-2.2-5.7-2c-2.1,0.1-4,1.1-5.3,2.7c-0.1,0.1-0.2,0.2-0.2,0.3\
								c-1.5-1.5-3.6-2.5-5.9-2.3c-4.3,0.3-7.6,4-7.3,8.4c0,0.5,0.4,2.5,0.6,3c0.2,0.7,0.5,1.5,0.9,2.3c-9-2.8-23.4-6.3-34.7,1.4\
								c-2.3,1.6-4.1,3.8-5.4,6.5c-4.3,0.1-7.6,2.8-8.2,6.8C2,45.2,2.6,47.3,4.1,49c1,1.2,2.4,2.1,4,2.6c0.5,9.6,3.4,18.5,3.5,18.8\
								c0.4,1.1,1.3,1.8,2.4,2c0.1,0,0.2,0,0.3,0c1,0,1.9-0.5,2.5-1.4C16.9,71,26.1,56.7,37.9,56.7z')

					.col-8
						h5 No testamos con animales.
						p.text-hint Somos libre de crueldad de todo tipo. Nuestros productos son testeados in vitro por bioalternatives [Fr].
						//- ayudando a la capacidad de autorregulación de la piel
						a.d-block(href='https://ongteprotejo.org/marcas-cruelty-free/?utm_source=paihuen.co&utm_medium=web', attr-animate="12",  target="blank_")
							span.certificacion
								img.teprotejo.mt-1.mb-5(src='images/teprotejo-logotype.svg', alt='certificación te protejo', height='40')
								span.url
									small ongteprotejo.org
		section(attr-animate='12').welcome.section-block
			.section-wrapper
				.welcome-image(attr-animate-fadeIn)
					.image(style="background-image: url('https://images.unsplash.com/photo-1517498327491-f903e1e281cd?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1280&q=30');")

				.welcome-content
					.container
						.row
							.col-12
								h6.mb-2 Impacto

								h1 Una elección personal con impacto global.

								p.lead.text-hint Tomamos la iniciativa e iniciamos el camino hacia el equilibrio.
								
								.buy-cta

									.btn-buy
										router-link.btn.btn-pill.btn-outline-primary(:to='"/filosofia"') 
											span Nuestra Filosofía

		include ../includes/footer.pug
</template>

<script>
	// :class="{active:activeMenu == 'a'}" , v-scrollWatch="{name:'a',offset:500,callback:spyDomChange}"
	
	import scrollWatch from "vue-scrollwatch"
	export default{
		name: 'home', 
		data() {
		    return {
		        activeMenu: 1,
		    }
		},
		methods:{
			spyDomChange(node) {
				if (this.activeMenu != node.name)
				this.activeMenu = node.name
			},
			scrollTo(name){
				scrollWatch.scrollTo(name)
			}
		}
	}
	
</script>